var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M9.00003 16.17L4.83003 12L3.41003 13.41L9.00003 19L21 7L19.59 5.59L9.00003 16.17Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }